import Button from '@mui/material/Button';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title?: string;
  onClickAddButton: () => void;
  disabled?: boolean;
};

function AddButton({ title, onClickAddButton, disabled }: Props) {
  const { t } = useTranslation('global');

  return (
    <div className="addButton">
      <Button
        data-testid="catalog-layout-add-button"
        disabled={disabled}
        onClick={onClickAddButton}
        size="large"
        sx={{
          backgroundColor: '#1D6FCC',
          color: '#FFF',
          height: 40,
          padding: '5px 10px'
        }}
        type="button"
        variant="contained"
        fullWidth
      >
        <span
          style={{
            fontSize: '30px',
            marginRight: 10
          }}
        >
          +
        </span>
        {title || t('common.commonProperties.newRegistration')}
      </Button>
    </div>
  );
}

export default memo(AddButton);
